import { Modal, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { ContractPropertyCard } from "apps/oneOnboarding/contract/ContractPropertyCard";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { PropertyData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";

interface Props {
    open: boolean;
    onAddLicense: () => void;
    onContinueAnyway: () => void;
    failedProperties: PropertyData[];
}

export const PropertyLicensePartialModal: FunctionComponent<Props> = ({
    open,
    onAddLicense,
    onContinueAnyway,
    failedProperties,
}) => {
    const {
        cmsData: {
            publish: { addLicenseToPublish, continueAnyway, addLicense, continueWithoutLicenseWarning },
        },
    } = useStaticDataAtomValue();

    return (
        <Modal
            visible={open}
            onClose={onAddLicense}
            title={addLicenseToPublish}
            size="m"
            actions={[
                {
                    actionType: "button",
                    variant: "label",
                    hierarchy: "secondary",
                    label: continueAnyway,
                    onClick: onContinueAnyway,
                },
                {
                    actionType: "button",
                    variant: "label",
                    hierarchy: "primary",
                    label: addLicense,
                    onClick: onAddLicense,
                },
            ]}
        >
            <VStack gap="8">
                {failedProperties.map((property) => (
                    <ContractPropertyCard
                        key={`failed-property-${property.propertyId}`}
                        name={property.propertyName}
                        photo={property.photos?.[0]?.src}
                        location={`${property.city?.name}, ${property.state?.name}`}
                    />
                ))}
            </VStack>
            <Typography variant="body-s" textColor="base.default">
                {continueWithoutLicenseWarning}
            </Typography>
        </Modal>
    );
};
